export const nfseWebhookTaxAuthorityErrorMappings2 = {
    NFSE_WEBHOOK_E0314_MUNICIPAL_TAX_CODE_INVALID: {
        code: 'NFSE_WEBHOOK_E0314_MUNICIPAL_TAX_CODE_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'O código de tributação municipal não existe ou não está administrado pelo município de incidência do ISSQN na data de competência. Verifique o código municipal nas configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'O código de tributação municipal não existe ou não está administrado pelo município de incidência do ISSQN na data de competência. Verifique o código municipal nas configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'The municipal taxation code does not exist or is not managed by the ISSQN incidence municipality on the competence date. Please check the municipal code in the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'El código de tributación municipal no existe o no está administrado por el municipio de incidencia del ISSQN en la fecha de competencia. Verifique el código municipal en la configuración de facturas.',
            },
        ],
        technicalMessage: 'O código de tributação municipal informado não existe ou não está administrado',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0315_MUNICIPAL_TAX_CODE_ZERO_INVALID: {
        code: 'NFSE_WEBHOOK_E0315_MUNICIPAL_TAX_CODE_ZERO_INVALID',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não é permitido informar 000 como código de tributação municipal. Informe um código municipal válido nas configurações de nota fiscal.',
            },
            {
                language: 'pt-BR',
                message: 'Não é permitido informar 000 como código de tributação municipal. Informe um código municipal válido nas configurações de nota fiscal.',
            },
            {
                language: 'en-US',
                message: 'The value 000 is not allowed as the municipal taxation code. Enter a valid municipal code in the invoice settings.',
            },
            {
                language: 'es-ES',
                message: 'No se permite informar 000 como código de tributación municipal. Ingrese un código municipal válido en la configuración de facturas.',
            },
        ],
        technicalMessage: 'Não é permitido informar 000 para o codigo de tributação municipal',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0595_ALIQUOTA_MAX_5_PERCENT: {
        code: 'NFSE_WEBHOOK_E0595_ALIQUOTA_MAX_5_PERCENT',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'A alíquota informada é superior ao limite de 5%. Verifique o ISS nas configurações.',
            },
            {
                language: 'pt-BR',
                message: 'A alíquota informada é superior ao limite de 5%. Verifique o ISS nas configurações.',
            },
            {
                language: 'en-US',
                message: 'The provided tax rate exceeds the 5% limit. Please check the ISS settings.',
            },
            {
                language: 'es-ES',
                message: 'La alícuota informada supera el límite del 5%. Verifique el ISS en la configuración.',
            },
        ],
        technicalMessage: 'Não é permitido informar alíquota superior a 5%',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E0600_ALIQUOTA_NOT_ALLOWED_MEI: {
        code: 'NFSE_WEBHOOK_E0600_ALIQUOTA_NOT_ALLOWED_MEI',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Não é permitido informar alíquota para MEI optante do Simples Nacional. Verifique as configurações.',
            },
            {
                language: 'pt-BR',
                message: 'Não é permitido informar alíquota para MEI optante do Simples Nacional. Verifique as configurações.',
            },
            {
                language: 'en-US',
                message: 'Tax rate is not allowed for MEI enrolled in Simples Nacional. Please check the settings.',
            },
            {
                language: 'es-ES',
                message: 'No se permite informar alícuota para MEI inscripto en Simples Nacional. Verifique la configuración.',
            },
        ],
        technicalMessage: 'Não é permitido informar a alíquota para prestador de serviço optante do simples nacional do tipo MEI',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_E999_UNCATALOGUED_ERROR: {
        code: 'NFSE_WEBHOOK_E999_UNCATALOGUED_ERROR',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Ocorreu um erro não catalogado. Tente novamente ou entre em contato com o suporte.',
            },
            {
                language: 'pt-BR',
                message: 'Ocorreu um erro não catalogado. Tente novamente ou entre em contato com o suporte.',
            },
            {
                language: 'en-US',
                message: 'An uncatalogued error occurred. Please try again or contact support.',
            },
            {
                language: 'es-ES',
                message: 'Ocurrió un error no catalogado. Intente nuevamente o contacte al soporte.',
            },
        ],
        technicalMessage: 'Erro não catalogado',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_L999_NACIONAL_EMISSOR_REQUIRED: {
        code: 'NFSE_WEBHOOK_L999_NACIONAL_EMISSOR_REQUIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Esta cidade exige emissão exclusivamente pelo Emissor Nacional da NFS-e. Entre em contato com o suporte para habilitar esta modalidade.',
            },
            {
                language: 'pt-BR',
                message: 'Esta cidade exige emissão exclusivamente pelo Emissor Nacional da NFS-e. Entre em contato com o suporte para habilitar esta modalidade.',
            },
            {
                language: 'en-US',
                message: 'This city requires issuance exclusively through the National NFS-e Issuer. Please contact support to enable this modality.',
            },
            {
                language: 'es-ES',
                message: 'Esta ciudad requiere emisión exclusivamente por el Emisor Nacional de NFS-e. Contacte al soporte para habilitar esta modalidad.',
            },
        ],
        technicalMessage: 'L999-https://www.nfse.gov.br/EmissorNacional',
        severity: 'error',
        critical: false,
    },
    NFSE_WEBHOOK_L12_SIMPLES_NACIONAL_NATIONAL_REQUIRED: {
        code: 'NFSE_WEBHOOK_L12_SIMPLES_NACIONAL_NATIONAL_REQUIRED',
        channel: 'IBK',
        domain: 'cobranca',
        userMessage: [
            {
                language: 'DEFAULT',
                message: 'Empresas do Simples Nacional e Sociedades Uniprofissionais (ISS Fixo) devem emitir exclusivamente pelo Emissor Nacional NFS-e nesta cidade. Entre em contato com o suporte para habilitar esta modalidade.',
            },
            {
                language: 'pt-BR',
                message: 'Empresas do Simples Nacional e Sociedades Uniprofissionais (ISS Fixo) devem emitir exclusivamente pelo Emissor Nacional NFS-e nesta cidade. Entre em contato com o suporte para habilitar esta modalidade.',
            },
            {
                language: 'en-US',
                message: 'Simples Nacional companies and Uniprofessional Societies (Fixed ISS) must issue exclusively through the National NFS-e Issuer in this city. Please contact support to enable this modality.',
            },
            {
                language: 'es-ES',
                message: 'Las empresas del Simples Nacional y Sociedades Uniprofesionales (ISS Fijo) deben emitir exclusivamente por el Emisor Nacional NFS-e en esta ciudad. Contacte al soporte para habilitar esta modalidad.',
            },
        ],
        technicalMessage: 'Proibida a emissão da NFS-e neste endereço eletrônico para empresas do Simples Nacional',
        severity: 'error',
        critical: false,
    },
};
